import { API_BASE_URL, AUTH_BASE_URL, endpoint, OPTIONS_ENDPOINTS } from '@/utils/endpoints';
import { getIndustryNames, industryHasProfessions, normalizeIndustryItem } from '@/utils/industries';
// import { Option } from '@/models/option.model';
import axios from 'axios';

export default {
	namespaced: true,

	state: {
		options: [],
		industries: [],
		heardFromOptions: [],
	},

	getters: {
		industries: state => state.industries,

		industryList: (_, getters) => getIndustryNames(getters.industries),

		professionalIndustryList: (_, getters) => getIndustryNames(getters.industries, { excludeEmptyProfessions: true }),

		professionList: (_, getters) => {
			let profession = [];

			for (let industry of getters.industries) {
				if (!industryHasProfessions(industry)) continue;
				if (industry.subs?.length) profession.push(...industry.subs);
				else if (industry.professions?.length) profession.push(...industry.professions.map(p => p.name).filter(Boolean));
			}

			return profession;
		},

		heardFromOptions: state => state.heardFromOptions,
	},

	mutations: {
		SET_OPTIONS(state, data) {
			state.options = data;
		},

		SET_INDUSTRIES(state, data) {
			state.industries = data;
		},

		SET_GENERAL_HEARD_FROM_OPTIONS(state, data) {
			state.heardFromOptions = data;
		},
	},

	actions: {
		async LoadOptions({ commit }) {
			try {
				const url = endpoint(API_BASE_URL, OPTIONS_ENDPOINTS.INDUSTRIES);
				const results = await axios.get(url);
				if (!results.data) throw window.$Error(window.$ERROR.ERR_REQUEST_FAILED, { parent: 'Failed to load options' });

				commit('SET_OPTIONS', results.data.data.Items);

				return results.data.data.Items;
			} catch (err) {
				throw window.$Error(window.$ERROR.ERR_REQUEST_FAILED, { parent: err });
			}
		},

		async LoadIndustries({ commit }, tenantId) {
			try {
				const url = endpoint(API_BASE_URL, OPTIONS_ENDPOINTS.TENANT_INDUSTRIES, {
					params: {
						tenantId,
					},
				});
				const results = await axios.get(url);
				if (!results.data) throw window.$Error(window.$ERROR.ERR_REQUEST_FAILED, { parent: 'Failed to load industries' });

				const items = (results.data.data.Items || []).map(normalizeIndustryItem);
				commit('SET_INDUSTRIES', items);

				return results.data.data.Items;
			} catch (err) {
				throw window.$Error(window.$ERROR.ERR_REQUEST_FAILED, { parent: err });
			}
		},

		async LoadHeardFromOptions({ commit }) {
			try {
				const url = endpoint(AUTH_BASE_URL, OPTIONS_ENDPOINTS.GET_GENERAL_HEARD_FROM_OPTIONS);

				const results = await axios.get(url);

				if (!results.data) throw window.$Error(window.$ERROR.ERR_REQUEST_FAILED, { parent: 'Failed to load heard from options' });

				commit('SET_GENERAL_HEARD_FROM_OPTIONS', results.data);
			} catch (err) {
				throw window.$Error(window.$ERROR.ERR_REQUEST_FAILED, { parent: err });
			}
		},
	},
};
